import BuyersTodos from "./BuyersTodos";

export default BuyersTodos;